define(
    'viewmodels/secured/explorer/details/tabs/details/details',[
        "viewmodels/secured/explorer/context",
        "services/service.documents",
        "plugins/router",
        "viewmodels/ViewModel",
        "providers/dataprovider",
        "extensions/file.extensions",
        "services/service.libraries",
        "services/service.dialog",
        "i19n!i19n/strings"
    ],
    function (ctx, documentService, router, ViewModel, dataProvider, fileExt, librariesService, dialogService, i19n) {

        var _documentDetails = [];
        var _documentVersions = [];
        var _documentHistory = [];
        var _documentClasses = [];

        var $gridvalues = null;
        var gridvalues = null;

        var vmHelper = getViewModelHelper();        

        //#region local i19n
        var _i19n = {
            historypane: {
                dialog: {
                    options: {
                        ok: {
                            label: i19n.to.restore,
                            message: i19n.to.thepriorrevisionselectedwillreplacethecurrentrevision
                        },
                        cancel: {
                            label: i19n.to.cancel,
                            message: ""
                        }
                    }
                }
            },
            form: {
                fields: {
                    title: {
                        label: i19n.to.title,
                        placeholder: i19n.to.enteradocumenttitle + "..."
                    },
                    category: {
                        label: i19n.to.category,
                        placeholder: i19n.to.choosecategory + "..."
                    },
                    docType: {
                        label: i19n.to.doctype,
                        placeholder: i19n.to.chooseadoctype + "..."
                    },
                    docDate: {
                        label: i19n.to.docdate,
                        placeholder: i19n.to.chooseadocdate + "..."
                    },
                    year: {
                        label: i19n.to.year,
                        placeholder: i19n.to.chooseayear + "..."
                    },
                    period: {
                        label: i19n.to.period,
                        placeholder: i19n.to.chooseaperiod + "..."
                    },
                    author: {
                        label: i19n.to.author,
                        placeholder: i19n.to.chooseanauthor + "..."
                    },
                    responsible: {
                        label: i19n.to.responsible,
                        placeholder: i19n.to.choosetheperson + "..."
                    },
                    hyperlink: {
                        label: i19n.to.link,
                        placeholder: i19n.to.enterahyperlink + "..."
                    },
                    location: {
                        label: i19n.to.location,
                        placeholder: i19n.to.choosealocation + "..."
                    },
                    index: {
                        label: i19n.to.index,
                        placeholder: i19n.to.chooseanindex + "..."
                    },
                    isDiscoverable: {
                        label: i19n.to.discoverable
                    },
                    isPrivileged: {
                        label: i19n.to.privileged
                    },
                    privilegedReason: {
                        label: i19n.to.privilegereason,
                        placeholoder: i19n.to.enterprivilegereason + "..."
                    },
                    dispatchDate: {
                        label: i19n.to.dispatchdate,
                        placeholder: i19n.to.enteradispatchdate + "..."
                    },
                    notes: {
                        label: i19n.to.notes,
                        placeholder: i19n.to.entersomenotes + "..."
                    },
                    amount: {
                        label: i19n.to.amount,
                        placeholder: i19n.to.enteranamount + "..."
                    },
                    importedFromFilePath: {
                        label: i19n.to.importedfromfilepath,
                        placeholder: i19n.to.enterpath + "..."
                    },
                    docStatus: {
                        label: i19n.to.docstatus,
                        placeholder: i19n.to.choosethedocumentstatus + "..."
                    },
                    lastReviewedBy: {
                        label: i19n.to.lastrevieweddby,
                        placeholder: i19n.to.chooseareviewer + "..."
                    },
                    lastReviewedDate: {
                        label: i19n.to.lastreviewed,
                        placeholder: i19n.to.chooselastrevieweddate + "..."
                    },
                    nextReviewDate: {
                        label: i19n.to.nextreview,
                        placeholder: i19n.to.choosenextreviewdate + "..."
                    },
                    nextReviewBy: {
                        label: i19n.to.reviewby,
                        placeholder: i19n.to.choosereviewer + "..."
                    },
                    assignedTo: {
                        label: i19n.to.assignedto,
                        placeholder: i19n.to.chooseassignto + "..."
                    },
                    sourceDocNumber: {
                        label: i19n.to.sourcedocnumber,
                        placeholder: i19n.to.entersourcedocumentnumber + "..."
                    },
                    ourDocNumber: {
                        label: i19n.to.ourdocnumber,
                        placeholder: i19n.to.enterdocumentnumber + "..."
                    },
                    isOkayToPublish: {
                        label: i19n.to.isitokaytopublish
                    },
                    archiveDate: {
                        label: i19n.to.archivedate,
                        placeholder: i19n.to.enteranarchivedate + "..."
                    },
                    destructionDate: {
                        label: i19n.to.destructiondate,
                        placeholder: i19n.to.enteradestructiondate + "..."
                    }
                }
            }
        };
        //#endregion

        var vm = new ViewModel({
            i19n: i19n,
            kendoGridVersion: null,
            kendoGridHistory: null,

            isAdmin: ko.observable(false),
            document: ko.observable(),

            editable: ko.observable(true),
            canEdit: ko.observable(true),

            isActiveTab: ko.observable(false),
            isActiveTabDetail: 'preview',                        
            isEmail: ko.observable(false),                        
                        
            isCheckedOutFieldSectionVisible: ko.observable(false),

            //#region fields
            fields: {                
                // checked out fields
                checkedOutSummary: vmHelper.getReadOnlyField(),

                // email fields
                sentDate: vmHelper.getReadOnlyField(),
                mailFrom: vmHelper.getReadOnlyField(),
                mailTo: vmHelper.getReadOnlyField(),
                mailCC: vmHelper.getReadOnlyField(),
                mailBC: vmHelper.getReadOnlyField(),
                subject: vmHelper.getReadOnlyField(),
                attachment: vmHelper.getReadOnlyField(),

                documentClass: {
                    dropdown: ko.observableArray(),
                    active: ko.observable({
                        id: '',
                        name: '',
                        isActive: ko.observable(false)
                    }),
                    reset: function (itm) {
                        if (vm.fields.documentClass.dropdown().length > 2) {
                            vm.fields.documentClass.dropdown()[0].isActive(0 == itm.id);
                            vm.fields.documentClass.dropdown()[1].isActive(1 == itm.id);
                            vm.fields.documentClass.dropdown()[2].isActive(2 == itm.id);
                        }
                    }
                },

                // summary fields
                docIdVersion: vmHelper.getReadOnlyField(),
                fileTypeSummary: vmHelper.getReadOnlyField(),
                pageCount: vmHelper.getReadOnlyField(),
                ext: vmHelper.getReadOnlyField(),
                basedOn: vmHelper.getReadOnlyField(),
                lastModified: vmHelper.getReadOnlyField(),
                created: vmHelper.getReadOnlyField(),
                parentDocIdVersion: vmHelper.getReadOnlyField(),
                isTextSearchable: vmHelper.getReadOnlyField(),
                basedOnTemplateDocIdVersion: vmHelper.getReadOnlyField(),
                icon: ko.observable(),
                filedIn: vmHelper.getReadOnlyField(),

                title: vmHelper.getTextField(7, "Title", _i19n.form.fields.title),
                docDate: vmHelper.getDateTimeField(28, "Doc Date", _i19n.form.fields.docDate),
                location: vmHelper.getLookupField(48, 3,"Location", "location", _i19n.form.fields.location),
                notes: vmHelper.getTextField(50, "Notes", _i19n.form.fields.notes, { rows: 4 }),
                hyperlink: vmHelper.getTextField(51, "Hyperlink", _i19n.form.fields.hyperlink),
                dispatchDate: vmHelper.getDateTimeField(52, "Dispatch Date", _i19n.form.fields.dispatchDate),
                period: vmHelper.getLookupField(54, 1, "Period", "period", _i19n.form.fields.period),
                docType: vmHelper.getLookupField(56, 0, "Doc Type", "docType", _i19n.form.fields.docType),
                category: vmHelper.getLookupField(58, 4, "Category", "category", _i19n.form.fields.category),
                index: vmHelper.getLookupField(60, 5, "Index", "index", _i19n.form.fields.index),
                docStatus: vmHelper.getLookupField(62, 6, "Doc Status", "docStatus", _i19n.form.fields.docStatus),
                lastReviewedDate: vmHelper.getDateField(68, "Last Review Date", _i19n.form.fields.lastReviewedDate),
                lastReviewedBy: vmHelper.getLookupField(70, "", "Last Reviewed By", "person", _i19n.form.fields.lastReviewedBy),
                nextReviewDate: vmHelper.getDateField(71, "Next Review Date", _i19n.form.fields.nextReviewDate),
                nextReviewBy: vmHelper.getLookupField(73, "", "Next Review By", "person", _i19n.form.fields.nextReviewBy),
                archiveDate: vmHelper.getDateField(74, "Archive Date", _i19n.form.fields.archiveDate),
                destructionDate: vmHelper.getDateField(75, "Destruction Date", _i19n.form.fields.destructionDate),
                author: vmHelper.getLookupField(79, "", "Author", "person", _i19n.form.fields.author),
                responsible: vmHelper.getLookupField(81, "", "Responsible Person", "person", _i19n.form.fields.responsible),
                isOkayToPublish: vmHelper.getCheckedField(82, "Is Okay To Publish", _i19n.form.fields.isOkayToPublish),
                isDiscoverable: vmHelper.getCheckedField(83, "Is Discoverable", _i19n.form.fields.isDiscoverable),
                isPrivileged: vmHelper.getCheckedField(84, "Is Privileged", _i19n.form.fields.isPrivileged),
                privilegedReason: vmHelper.getLookupField(86, 2, "Privileged Reason", "privilegedReason", _i19n.form.fields.privilegedReason),
                sourceDocNumber: vmHelper.getTextField(87, "Source Doc Number", _i19n.form.fields.sourceDocNumber),
                ourDocNumber: vmHelper.getTextField(88, "Our Doc Number", _i19n.form.fields.ourDocNumber),
                importedFromFilePath: vmHelper.getTextField(89, "Imported From File Path", _i19n.form.fields.importedFromFilePath),
                amount: vmHelper.getNumberField(94, "Amount", _i19n.form.fields.amount, { format: "n3" }),
                year: vmHelper.getLookupField(96, 7, "Year", "year", _i19n.form.fields.year),
                assignedTo: vmHelper.getLookupField(123, "", "Assigned To", "person", _i19n.form.fields.assignedTo),
                
                path: vmHelper.getPathOnly()                
            },
            //#endregion

            //#region version
            version: {
                alertMessage: ko.observable(),
                documentVersion: ko.observable(),
                documentStatus: ko.observable(),
                documentVersionList: ko.observable(),
                duplicateAsVersionText: ko.observable(),
                uploadAsVersionText: ko.observable(),
                versionNotes: ko.observable(),
                documentId: ko.observable(),
                documentStatusId: ko.observable(),
                documentIdVersion: ko.observable(),                                           
                isCurrentVersion: ko.observable(false),
                versionNotesUpdated: ko.observable(),
                versionNotesFocused: ko.observable(),
                versionNotesIsDirty: ko.observable(false),
                initVersionText: ko.observable(i19n.to.documenttomakethisversion_),
                duplicateVersionAsVersionText: ko.observable(i19n.to.duplicateversion_asversion_),
                isShowConfirmDuplicate: ko.observable(false)
            },
            //#endregion

            //#region history
            history: {
                historyList: ko.observable(),
                documentId: ko.observable(),
                revDocumentId: ko.observable(),
                revisionNo: ko.observable()
            },
            //#endregion

            isGuest: ko.observable(false),
            isRefresh: ko.observable(false),

            isStandardFieldSectionVisible: ko.pureComputed(function () {
                var v = vm.fields.title.visible() || vm.fields.category.visible() || vm.fields.docType.visible() || vm.fields.docDate.visible() || 
                        vm.fields.year.visible() || vm.fields.period.visible();

                return v;
            }),
            isExtraFieldSectionVisible: ko.pureComputed(function () {
                var v = vm.fields.author.visible() || vm.fields.responsible.visible() || vm.fields.hyperlink.visible() || vm.fields.location.visible() ||
                        vm.fields.index.visible() || vm.fields.isDiscoverable.visible() || vm.fields.isPrivileged.visible() || vm.fields.privilegedReason.visible() ||
                        vm.fields.dispatchDate.visible() || vm.fields.notes.visible() || vm.fields.amount.visible() || vm.fields.importedFromFilePath.visible();
                
                return v;
            }),
            isDocControlFieldSectionVisible: ko.pureComputed(function () {
                var v = vm.fields.docStatus.visible() || vm.fields.lastReviewedDate.visible() || vm.fields.lastReviewedBy.visible() || vm.fields.nextReviewDate.visible() ||
                        vm.fields.nextReviewBy.visible() || vm.fields.assignedTo.visible() || vm.fields.sourceDocNumber.visible() || vm.fields.ourDocNumber.visible() ||
                        vm.fields.isOkayToPublish.visible();

                return v;
            }),
            isArchiveFieldSectionVisible: ko.pureComputed(function () {
                var v = vm.fields.archiveDate.visible() || vm.fields.destructionDate.visible();

                return v;
            })
        });
        
        vm.load = function (document) {
            vm.editLayout.isShowHideField(false);
            if (vm.editLayout.isEditLayout()) {
                vm.editLayout();
            }
            vm.document(document);

            if (!vm.isActiveTab())
                return;

            if (document && document.documentId != vm.version.documentId()) {
                vm.version.versionNotesUpdated(false);
                vm.version.versionNotesIsDirty(false);

                $("#alertMessage").hide();
                $("#versionNotes").removeClass('updated');

                if ($("#seedversion").data("kendoNumericTextBox")) {
                    $("#seedversion").data("kendoNumericTextBox").value(1);
                }
            }

            _load(vm.document());

            //#region commented
            //FPA-1375 - for hiding warning message when user is readonly publish on the selected document
            // need further implementation for list
            //vm.session
            //.getRoleLibrary(document.libraryId)
            //.done(function (role) {
            //    console.warn(role);                    
            //});
            //#endregion
        };

        vm.activate = function () {
            vm.$grid = null;

            vm.isGuest(vm.session.role == 0 || vm.session.role == 1 ? true : false);
            vm.isAdmin(vm.session.role == 3 || vm.session.role == 4 ? true : false);
        };
        vm.attached = function () {            
            vm.version.initVersionText(String.format(i19n.to.documenttomakethisversion_, '1'));

            $("#previewView").show();            
            $("#fldView").hide();
            $("#versionView").hide();
            $("#historyView").hide();

            $("#alertMessage").hide();

            $("#versionNotes").focusin(function () {
                $("#versionNotes").removeClass('updated');
            });

            $("#btnVersionCancel").click(function () {
                $("#noversion").show();
                $("#withversion").hide();
            });
            $("#seedversion").kendoNumericTextBox({
                format: "n0",
                min: 0,
                max: 999,
                value: 1,
                spin: function () {
                    var text = String.format(i19n.to.documenttomakethisversion_, this.value());
                    vm.version.initVersionText(text);
                },
                change: function () {
                    var text = String.format(i19n.to.documenttomakethisversion_, this.value());
                    vm.version.initVersionText(text);
                }
            });

            $gridvalues = $("#values-grid");           

            buildGridValues();

            gridvalues.table.off("click", ".isincluded-id:checkbox", isIncludedClick);
            gridvalues.table.on("click", ".isincluded-id:checkbox", isIncludedClick);

            //$(".k-grid-popup", gridvalues.element).on("click", function (e) {
            //    //gridvalues.options.editable = "popup";
                
            //    gridvalues.addRow();
                
            //    //gridvalues.options.editable = "inline";

            //    e.stopPropagation();
            //    e.preventDefault();

            //    return false;
            //});

            function buildGridValues() {
                gridvalues = $gridvalues.kendoGrid({
                    dataSource: getGridValuesDataSource(),
                    //toolbar: [{text: "Add New Value", name: "popup", iconClass: "k-icon k-add" }],
                    resizable: true,
                    reorderable: true,
                    sortable: true,
                    columns: [
                        { field: "id", hidden: true },
                        { field: "isIncluded", title: i19n.to.include, width: 60, template: "<input class='isincluded-id' style='height:18px' type='checkbox' data-bind='checked:isIncluded' #= isIncluded? 'checked=checked' : '' #/>" }, //onClick='return false'
                        { field: "name", title: i19n.to.fieldvalue },
                        {
                            command: [
                              { name: "edit", text: i19n.to.edit },
                              { name: "destroy", text: i19n.to.delete }
                            ],
                            title: "&nbsp;",
                            width: 170
                        }
                    ],
                    scrollable: { virtual: true },
                    editable: { mode: "inline" },
                    edit: function (e) {
                        //e.container.find(".k-edit-label:first").hide();
                        //e.container.find("input[name=id]").hide();

                        //if (e.model.id.length == 0) {
                        //    $(".k-window-title").text('Add New Value');
                        //} else {
                        //    $(".k-window-title").text('Edit Value');
                        //}
                    },
                    height: 530
                }).data("kendoGrid");
            };
            function getGridValuesDataSource() {
                return new kendo.data.DataSource({
                    transport: {
                        read: function (callbacks) {
                            
                            if (vm.editLayout.lookupId() === '') {
                                callbacks.success([]);

                                return;
                            }

                            dataProvider.libraries
                            .getProfileFieldValues(vm.editLayout.lookupId(), vm.document().libraryId)
                            .done(function (data) {
                                data = _.sortBy(data, function (itm) { return itm.name; });

                                callbacks.success(data);
                            })
                            .fail(function (e) {
                                console.error(e);
                            });
                        },
                        update: function (callbacks) {
                            dataProvider.libraries
                            .updateProfileFieldValues(callbacks.data.id, callbacks.data.lookupId, { name: callbacks.data.name, isIncluded: callbacks.data.isIncluded })
                            .done(function (result) {
                                //self.notify('success', callbacks.data.name + ' ' + i19n.to.updated);

                                dataProvider.libraries
                                .includeProfileFieldValueToLibrary(callbacks.data.id, vm.document().libraryId, callbacks.data.isIncluded)
                                .done(function (result) {
                                    //self.notify('success', callbacks.data.name + ' ' + (callbacks.data.isIncluded ? i19n.to.hasbeenincludedinlibrary : i19n.to.hasbeenexcludedfromlibrary));

                                    callbacks.success();
                                })
                                .fail(function (e) {
                                    e.stopPropagation = true;

                                    //self.notify(e.error);

                                    callbacks.error(e.error);

                                    console.error(e);
                                });
                            })
                            .fail(function (e) {
                                e.stopPropagation = true;

                                //self.notify(e.error);

                                callbacks.error(e.error);

                                console.error(e);
                            });
                        },
                        create: function (callbacks) {
                            dataProvider.libraries
                            .createProfileFieldValues(vm.editLayout.lookupId(), { name: callbacks.data.name, isIncluded: callbacks.data.isIncluded })
                            .done(function (result) {
                                //self.notify('success', callbacks.data.name + ' ' + i19n.to.updated);

                                gridvalues.dataSource.read();

                                if (callbacks.data.isIncluded) {
                                    dataProvider.libraries
                                    .includeProfileFieldValueToLibrary(result, vm.document().libraryId, true)
                                    .done(function (result) {

                                        callbacks.success();

                                        //self.notify('success', callbacks.data.name + ' ' + i19n.to.hasbeenincludedinlibrary);
                                    })
                                    .fail(function (e) {
                                        e.stopPropagation = true;

                                        //self.notify(e.error);

                                        console.error(e);
                                    });
                                } else {
                                    callbacks.success();
                                }
                            })
                            .fail(function (e) {
                                e.stopPropagation = true;

                                //self.notify(e.error);

                                callbacks.error(e.error);

                                console.error(e);
                            });
                        },
                        destroy: function (callbacks) {
                            var dialogoptions = { ok: { label: 'Yes', message: '' }, cancel: { label: 'No', message: '' } };

                            dialogService.showMessageBox(i19n.to.confirmdelete, i19n.to.delete + ' ' + callbacks.data.name + ' ?', _.toArray(dialogoptions))
                            .then(function (action) {
                                if (action == dialogoptions.cancel) {
                                    gridvalues.cancelChanges();
                                }
                                if (action == dialogoptions.ok) {
                                    dataProvider.libraries
                                    .includeProfileFieldValueToLibrary(callbacks.data.id, vm.document().libraryId, false)
                                    .done(function (result) {
                                        //self.notify('success', callbacks.data.name + ' ' + i19n.to.hasbeenexcludedfromlibrary);

                                        dataProvider.libraries
                                        .deleteProfileFieldValues(vm.editLayout.lookupId(), callbacks.data.id)
                                        .done(function (result) {
                                            //self.notify('success', callbacks.data.name + ' ' + i19n.to.deleted);

                                            callbacks.success();
                                        })
                                        .fail(function (e) {
                                            e.stopPropagation = true;

                                            gridvalues.cancelChanges();

                                            callbacks.error(e.error);

                                            console.error(e);
                                        });
                                    })
                                    .fail(function (e) {
                                        e.stopPropagation = true;

                                        //self.notify(e.error);

                                        console.error(e);
                                    });
                                }
                            });
                        }
                    },
                    schema: {
                        model: {
                            id: "id",
                            fields: {
                                id: { type: "string" },
                                isIncluded: { type: "boolean" },
                                name: { type: "string" }
                            }
                        }
                    },
                    pageSize: 999
                });
            }
            function isIncludedClick(e) {
                var row = gridvalues.dataItem($(this).closest("tr"));
                var val = !row.isIncluded;

                row.isIncluded = val;

                $(this).prop('checked', val);

                e.stopPropagation();

                saveFieldValues(row.id, row.lookupId, row.name, val);
            }
            function saveFieldValues(id, lookupId, name, isIncluded) {
                dataProvider.libraries
                .updateProfileFieldValues(id, lookupId, { name: name, isIncluded: isIncluded })
                .done(function (result) {
                    //vm.notify('success', name + ' ' + i19n.to.updated);

                    dataProvider.libraries
                    .includeProfileFieldValueToLibrary(id, vm.document().libraryId, isIncluded)
                    .done(function (result) {
                        //vm.notify('success', name + ' ' + (isIncluded ? i19n.to.hasbeenincludedinlibrary : i19n.to.hasbeenexcludedfromlibrary));
                    })
                    .fail(function (e) {
                        e.stopPropagation = true;

                        //vm.notify(e.error);

                        console.error(e);
                    });
                })
                .fail(function (e) {
                    e.stopPropagation = true;

                    //vm.notify(e.error);

                    console.error(e);
                });
            }

            vm.fields.title.description = i19n.to.thedocumentstitle;
            vm.fields.category.description = i19n.to.categorizedocumentsbyorigin;
            vm.fields.docType.description = i19n.to.recordthetypeofdocumentsuchasletter;
            vm.fields.docDate.description = i19n.to.assignadateandtimetodocumentsseparatefromthecreationdate;
            vm.fields.year.description = i19n.to.assignafinancialorcalendaryeartoadocument;
            vm.fields.period.description = i19n.to.assignatimeperiodtoadocumentperiodscouldbedays;
            vm.fields.author.description = i19n.to.thepersonthatistheauthorofthedocument;
            vm.fields.responsible.description = i19n.to.thepersonthatisresponsibleforthe;
            vm.fields.hyperlink.description = i19n.to.holdsahyperlinkthatrelatestoadocument;
            vm.fields.location.description = i19n.to.allowsalocationtobeassignedtoadocument;
            vm.fields.index.description = i19n.to.assignanindexvaluetoadocument;
            vm.fields.isDiscoverable.description = i19n.to.ayesnofieldsuseinlegalenvironmentsdiscoverable;
            vm.fields.isPrivileged.description = i19n.to.ayesnofieldsuseinlegalenvironmentsprivileged;
            vm.fields.privilegedReason.description = i19n.to.afieldusedinlegalenvironmentstodenoteifadocumentpriviledged;
            vm.fields.notes.description = i19n.to.allowslongnotestoberecordedaboutadocument;
            vm.fields.dispatchDate.description = i19n.to.thedateadocumentwasdispatched;
            vm.fields.amount.description = i19n.to.enteracurrencyamountapplicabletothedocument;
            vm.fields.importedFromFilePath.description = i19n.to.fordocumentssavedautomaticallybythefileplandocumentimporter;
            vm.fields.docStatus.description = i19n.to.assignedastatustothedocumentsuchasdraft;
            vm.fields.lastReviewedDate.description = i19n.to.thedatethedocumentwaslastreviewed;
            vm.fields.lastReviewedBy.description = i19n.to.thepersonthatlastreviewedthecontentofthedocument;
            vm.fields.nextReviewDate.description = i19n.to.thedatethedocumentisnextdueforreview;
            vm.fields.nextReviewBy.description = i19n.to.thepersonthatwillnextreviewthecontentofthedocument;
            vm.fields.assignedTo.description = i19n.to.thepersonthatisresponsibletonexttakeactiononthedocument;
            vm.fields.sourceDocNumber.description = i19n.to.thesourcedocumentnumberfordocumentsthatcomefromanexternalorganisation;
            vm.fields.ourDocNumber.description = i19n.to.anoptionaldocumentnumberthatcouldbeassignedtoadocument;
            vm.fields.isOkayToPublish.description = i19n.to.ayesnofieldthatrecordsthestatusofadocumentasapprovedtopublish;
            vm.fields.archiveDate.description = i19n.to.thedatethedocwasarchivedorisdue;
            vm.fields.destructionDate.description = i19n.to.thedatethedocumentwasdestroyedorisdue;

            $("#explorer-details-doc-details").parent().parent().scroll(function () {
                var y = $("#explorer-details-doc-details").parent().parent().scrollTop() - 50; y = y < 0 ? 0 : y;
                $("#field-property").css({ 'padding-top': y + 'px' });
            });
           

            function resizePreview() {
                var $iframe = $("#preview-iframe");
                $iframe.height($(document).height() - 180);

                $("#previewView").height($(document).height() - 180);
            }

            resizePreview();
            $(window).resize(function () {            
                resizePreview();
            });
        };
        
        vm.version.versionNotesFocused.subscribe(function (newvalue) {
            if (!newvalue) {
                if (vm.version.versionNotesIsDirty()) {
                    vm.version.versionNotes($("#versionNotes").val());

                    saveDocumentVersion({ versionNotes: vm.version.versionNotes() })
                    .done(function () {
                        
                        var docVersion = _cacheUpdateVersionNotes(vm.document().documentId, vm.version.versionNotes());

                        vm.version.versionNotesUpdated(true);
                        vm.version.versionNotesIsDirty(false);
                        //$("#versionNotes").addClass('updated');

                        vm.version.alertMessage(i19n.to.versionnotesupdated + " " + vm.version.documentIdVersion());

                        $("#alertMessage").show();
                    })
                    .fail(function (e) {
                        console.error(e);
                    });
                }
            } else {
                vm.version.versionNotesUpdated(false);
            }
        });

        vm.alertClose = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                $("#alertMessage").hide();

                complete();
            }
        });
        vm.refresh = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                if (vm.editLayout.isShowHideField()) {
                    complete();
                    return;
                }

                _load(vm.document(), true)
                .done(function () {})
                .always(function () {
                    complete();
                });
            }
        });
        vm.showPreview = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                vm.isActiveTabDetail = 'preview';

                $("#shwPreview").parent().addClass("active");
                $("#shwProfile").parent().removeClass();
                $("#shwVersion").parent().removeClass();                
                $("#shwHistory").parent().removeClass();

                $("#previewView").show();
                $("#fldView").hide();
                $("#versionView").hide();
                $("#historyView").hide();

                complete();
            }
        });
        vm.showProfile = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                vm.isActiveTabDetail = 'profile';

                _loadDetails(vm.document())
                .done(function () {
                    
                    $("#shwPreview").parent().removeClass();
                    $("#shwProfile").parent().addClass("active");
                    $("#shwVersion").parent().removeClass();
                    $("#shwHistory").parent().removeClass();
                    
                    $("#previewView").hide();
                    $("#fldView").show();
                    $("#versionView").hide();
                    $("#historyView").hide();
                })
                .always(function () {
                    complete();
                });
            }
        });
        vm.showVersion = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                vm.isActiveTabDetail = 'version';
                
                _loadVersion(vm.document().documentId, false)
                .done(function () {

                    $("#shwPreview").parent().removeClass();
                    $("#shwProfile").parent().removeClass();
                    $("#shwVersion").parent().addClass("active");
                    $("#shwHistory").parent().removeClass();

                    $("#previewView").hide();
                    $("#fldView").hide();
                    $("#versionView").show();
                    $("#historyView").hide();                
                })
                .always(function () {
                    complete();
                });
            }
        });
        vm.showHistory = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                vm.isActiveTabDetail = 'history';
                
                _loadHistory(vm.document().documentId)
                .done(function () {
                    $("#shwPreview").parent().removeClass();
                    $("#shwProfile").parent().removeClass();                    
                    $("#shwVersion").parent().removeClass();
                    $("#shwHistory").parent().addClass("active");

                    $("#previewView").hide();
                    $("#fldView").hide();
                    $("#versionView").hide();
                    $("#historyView").show();
                })
                .always(function () {
                    complete();
                });
            }
        });

        //#region Edit Layout

        vm.editLayout = function () {                       

            var b = !vm.editLayout.isEditLayout();
            var w = b ? 860 : 460;

            window.fp.explorerLayout.sizePane("east", w);            

            vm.editLayout.isEditLayout(b);

            if (!b) {
                vm.refresh();
            }
        };
        vm.editLayout.isEditLayout = ko.observable(false);
        
        vm.editLayout.lookupId = ko.observable('');
        vm.editLayout.showHideField = function () {
            vm.editLayout.isShowHideField(!vm.editLayout.isShowHideField());

            if (!vm.editLayout.isShowHideField()) {
                vm.editLayout.isEditLayout(true);
                vm.editLayout();
            }
        };
        vm.editLayout.isShowHideField = ko.observable(false);
        vm.editLayout.isShowHideField.subscribe(function (value) {
            _resetFocus();

            var b = value;

            _.map(vm.fields, function (itm) {
                if (itm.fieldId != null) {
                    itm.editLayout(b);
                    itm.editLayout.focus = function (value) {
                        var y = $("#explorer-details-doc-details").parent().parent().scrollTop() - 50; y = y < 0 ? 0 : y;
                        $("#field-property").css({ 'padding-top': y + 'px' });
                        _resetFocus();
                        itm.editLayout.isFocus(true);
                        
                        vm.editLayout.isEditLayout(false);
                        vm.editLayout();
                        vm.editLayout.field(itm);
                        vm.editLayout.lookupId(itm.lookupId);

                        gridvalues.dataSource.read();
                    };
                    //itm.editLayout.editList = function (value) {
                    //    _resetFocus();
                    //    itm.editLayout.isFocus(true);

                    //    vm.editLayout.isEditLayout(false);
                    //    vm.editLayout();
                        
                    //    vm.editLayout.lookupId (itm.lookupId);
                    //    gridvalues.dataSource.read();
                    //};
                }
            });

            function _resetFocus() {
                _.map(vm.fields, function (itm) {
                    if (itm.fieldId != null) {
                        itm.editLayout.isFocus(false);
                    }
                });                
            }
        });
        vm.editLayout.field = ko.observable(null);

        vm.editLayout.save = function (fieldId, visible) {
            
            if (!vm.editLayout.isShowHideField()) {
                return;
            }

            var fields = [];
            _.map(vm.fields, function (itm) {
                if (itm.fieldId != null) {
                    fields.push({
                        documentFieldId: itm.fieldId,
                        isDisplayedInProfile: itm.visible(),
                        fieldName: itm.fieldName
                    });
                } 
            });

            if (fields.length) {
                dataProvider.libraries
                .updateProfileFields(vm.document().libraryId, fields)
                .done(function (result) {
                })
                .fail(function (e) {
                    //how to reverse when error occured without infinite loop?
                    //vm.fields[field].visible(!visible);

                    console.error(e);
                })
                .always(function () {
                    _documentDetails = [];
                });

            }
        };
        vm.editLayout.addFieldValue = function () {
            gridvalues.addRow();
        };
        //#endregion

        //#region Preview
        var _documentPreviews = [];

        function _loadPreview(document) {
            if (document) {

                preview(document.documentId, false);

            } else {
                try {
                    var iframe = window.document.getElementById('preview-iframe');
                    if (!iframe) {
                        //console.error("preview-iframe does not exist");
                        return;
                    }
                    var w = iframe.contentWindow || iframe.contentDocument;

                    if (w && w.document) {
                        var wdoc = w.document;

                        wdoc.open();
                        wdoc.clear();
                        wdoc.write('');
                        wdoc.close();
                    }
                }
                catch (ex) {
                    console.error(ex);
                }
            }
        }

        function preview(documentId, refresh) {
            refresh = refresh || false;

            _cacheGetPreview(documentId, refresh)
            .done(function (result) {
                var iframe = window.document.getElementById('preview-iframe');

                if (!iframe)
                    return;

                var w = iframe.contentWindow || iframe.contentDocument;

                if (w && w.document) {
                    var wdoc = w.document;

                    wdoc.open();
                    wdoc.clear();
                    
                    //ALSO IN DOWNLOAD PREVIEW
                    try {
                        if (result.encoding.indexOf('text/html') != -1) {
                            wdoc.write(decodeURI(result.data));

                            var span = wdoc.getElementsByClassName('auto-style1');
                            if (span.length) span[0].style.width = "auto";
                        }
                        else if (result.encoding.indexOf('text/plain') != -1) {
                            wdoc.write(decodeURI(result.data));
                        }
                        else if (result.encoding.indexOf('image/') != -1) {
                            wdoc.write('<img style="display:block;" src="' + String.format("{0}{1}", result.encoding, result.data) + '"></img>');
                        }
                        else {
                            wdoc.write('unidentified encoding');
                            console.warn('unidentified encoding : ' + result.encoding);
                        }
                    }
                    catch (e) {
                        console.error(e);
                    }

                    wdoc.close();
                }
            })
            .fail(function (e) {
                e.stopPropagation = true;
            });
        }

        function _cacheGetPreview(documentId, refresh) {
            var d = $.Deferred();

            refresh = refresh || false;

            var f = _.find(_documentPreviews, function (itm) { return !itm ? false : itm.documentId == documentId; });
            if (refresh)
                _documentPreviews = _.without(_documentPreviews, f);

            if (f && !refresh) {
                d.resolve(f);
            } else {
                //controller.isBusy(true);

                dataProvider.documents
                .getDocumentPreview(documentId)
                .done(function (results) {
                    results.documentId = documentId;

                    _documentPreviews.push(results);

                    d.resolve(results);
                })
                .fail(function (e) {
                    d.reject(e);

                    console.error(e);
                })
                .always(function () {
                    //controller.isBusy(false);
                });
            }

            return d.promise();
        }
        //#endregion

        //#region Profile
        function _loadDetails(document, refresh) {
            vm.isRefresh(refresh);

            //#region map fields   
            function mapDocumentClass(data, id) {
                return _.map(data, function (itm) {
                    return {
                        id: itm.id,
                        name: itm.name,
                        isActive: ko.observable(itm.id == id)
                    };
                });
            }
            function mapFileTypeSummary(details) {
                var pageCount = details.pageCount || 0;
                var extension = details.extension || i19n.to.unknown;
                var fileSize = details.fileSize || "";

                return String.format("{0} {1}, {2}, " + i19n.to.extension + ": {3}", pageCount, pageCount == 1 ? i19n.to.page : i19n.to.pages, fileSize, extension);
            }
            function mapEmailTypeSummary(email, details) {
                var attachmentCount = email.attachmentCount || 0;
                var fileSize = details.fileSize || "";

                return String.format("{0} {1}, {2}", attachmentCount, attachmentCount == 1 ? i19n.to.attachment : i19n.to.attachments, fileSize);
            }
            function mapLastModified(details) {
                var lastModifiedBy = details.lastModifiedBy && details.lastModifiedBy.value ? details.lastModifiedBy.value : i19n.to.NA;
                var lastModifiedDate = details.lastModifiedDate ? kendo.toString(kendo.parseDate(details.lastModifiedDate), "g") : ""; //d MMM yyyy hh:mm tt

                return String.format("{0} {1}", lastModifiedBy, lastModifiedDate);
            }
            function mapCreated(details) {
                var createdBy = details.createdBy && details.createdBy.value ? details.createdBy.value : i19n.to.NA;
                var createdDate = details.createdDate ? kendo.toString(kendo.parseDate(details.createdDate), "g") : ""; //d MMM yyyy hh:mm tt

                return String.format("{0} {1}", createdBy, createdDate);
            }
            function mapCheckedOut(details) {
                var checkedOutBy = details.checkedOutBy && details.checkedOutBy.value ? details.checkedOutBy.value : i19n.to.NA;
                var checkedOutDate = details.checkedOutDate ? kendo.toString(kendo.parseDate(details.checkedOutDate), "g") : "";

                return String.format(i19n.to.checkedoutby + " {0} {1}", checkedOutBy, checkedOutDate);
            }
            //#endregion         

            vm.editable(!(document.accessControlRoleId == 20 || document.accessControlRoleId == 30));
            vm.canEdit(!(document.accessControlRoleId == 20 || document.accessControlRoleId == 30));

            // TODO: is there a webapi that says "control status is editable?
            _loadVersion(document.documentId, false);

            return _cacheGetDetails(document.documentId, document.libraryId, refresh)
            .done(function (results) {
                var details = results.details;
                var email = results.email;                

                //getDocumentClasses()
                //.done(function (data) {
                //    var classes = mapDocumentClass(data, details.documentClass);
                //    console.warn(data);
                //    vm.fields.documentClass.dropdown(classes);
                //    vm.fields.documentClass.active(classes[details.documentClass]);
                //});

                var cs = mapDocumentClass([{ id: 0, name: 'Working' }, { id: 1, name: 'Email' }, { id: 2, name: 'Controlled' }], details.documentClass);

                vm.fields.documentClass.dropdown(cs);
                vm.fields.documentClass.active(cs[details.documentClass]);

                //#region Map fields

                // checked out
                vm.isCheckedOutFieldSectionVisible(details.checkedOutBy && details.checkedOutDate);

                if (vm.isCheckedOutFieldSectionVisible()) {
                    vmHelper.mapToReadOnlyField(vm.fields.checkedOutSummary, mapCheckedOut(details));
                }

                // email
                vm.isEmail(email !== undefined);
             
                if (vm.isEmail()) {
                    vmHelper.mapToReadOnlyField(vm.fields.sentDate, email.sentDate, function (value) { return kendo.toString(kendo.parseDate(value), "g"); });
                    vmHelper.mapToReadOnlyField(vm.fields.mailFrom, email.mailFrom, null, "mailFrom");
                    vmHelper.mapToReadOnlyField(vm.fields.mailTo, email.mailTo);
                    vmHelper.mapToReadOnlyField(vm.fields.mailCC, email.mailCC);
                    vmHelper.mapToReadOnlyField(vm.fields.mailBC, email.mailBC);
                    vmHelper.mapToReadOnlyField(vm.fields.subject, email.subject);
                    vmHelper.mapToReadOnlyField(vm.fields.attachment, email.attachmentCount || 0);
                    vmHelper.mapToReadOnlyField(vm.fields.fileTypeSummary, mapEmailTypeSummary(email, details));
                } else {
                    vmHelper.mapToReadOnlyField(vm.fields.fileTypeSummary, mapFileTypeSummary(details));
                    vmHelper.mapToReadOnlyField(vm.fields.pageCount, details.pageCount || 0);
                    vmHelper.mapToReadOnlyField(vm.fields.ext, details.extension || i19n.to.unknown);
                    vmHelper.mapToReadOnlyField(vm.fields.basedOn, details.basedOnTemplateDocIdVersion || i19n.to.none);
                }

                // summary fields   
                vm.fields.icon(fileExt.getApplicationTypeIcon(details.applicationType));

                vmHelper.mapToReadOnlyField(vm.fields.lastModified, mapLastModified(details));
                vmHelper.mapToReadOnlyField(vm.fields.created, mapCreated(details));
                vmHelper.mapToReadOnlyField(vm.fields.docIdVersion, details.docIdVersion);
                vmHelper.mapToReadOnlyField(vm.fields.parentDocIdVersion, details.parentDocIdVersion);
                vmHelper.mapToReadOnlyField(vm.fields.isTextSearchable, details.isTextSearchable, function (value) { return value == null ? null : (value ? i19n.to.yes : i19n.to.no); });
                vmHelper.mapToReadOnlyField(vm.fields.basedOnTemplateDocIdVersion, details.basedOnTemplateDocIdVersion);
                vmHelper.mapToReadOnlyField(vm.fields.filedIn, details.filedIn);

                // standard fields
                vmHelper.mapToTextField(vm.fields.title, details, "title");
                vmHelper.mapToLookupField(vm.fields.category, details, "category");
                vmHelper.mapToLookupField(vm.fields.docType, details, "docType");
                vmHelper.mapToDateTimeField(vm.fields.docDate, details, "docDate");
                vmHelper.mapToLookupField(vm.fields.year, details, "year");
                vmHelper.mapToLookupField(vm.fields.period, details, "period");

                // extra fields
                vmHelper.mapToLookupField(vm.fields.author, details, "author");
                vmHelper.mapToLookupField(vm.fields.responsible, details, "responsiblePerson"); //old field name was responsible
                vmHelper.mapToTextField(vm.fields.hyperlink, details, "hyperlink");
                vmHelper.mapToLookupField(vm.fields.location, details, "location");
                vmHelper.mapToLookupField(vm.fields.index, details, "index");
                vmHelper.mapToCheckedField(vm.fields.isDiscoverable, details, "isDiscoverable");
                vmHelper.mapToCheckedField(vm.fields.isPrivileged, details, "isPrivileged");
                vmHelper.mapToLookupField(vm.fields.privilegedReason, details, "privilegedReason"); //old field name was privilegeReason
                vmHelper.mapToDateTimeField(vm.fields.dispatchDate, details, "dispatchDate");
                vmHelper.mapToTextField(vm.fields.notes, details, "notes");
                vmHelper.mapToNumberField(vm.fields.amount, details, "amount");
                vmHelper.mapToTextField(vm.fields.importedFromFilePath, details, "importedFromFilePath");

                // document control
                vmHelper.mapToLookupField(vm.fields.docStatus, details, "docStatus");
                vmHelper.mapToDateField(vm.fields.lastReviewedDate, details, "lastReviewDate"); //old field name was lastReviewedDate
                vmHelper.mapToLookupField(vm.fields.lastReviewedBy, details, "lastReviewedBy");
                vmHelper.mapToDateField(vm.fields.nextReviewDate, details, "nextReviewDate");
                vmHelper.mapToLookupField(vm.fields.nextReviewBy, details, "nextReviewBy");
                vmHelper.mapToLookupField(vm.fields.assignedTo, details, "assignedTo");
                vmHelper.mapToTextField(vm.fields.sourceDocNumber, details, "sourceDocNumber");
                vmHelper.mapToTextField(vm.fields.ourDocNumber, details, "ourDocNumber");
                vmHelper.mapToCheckedField(vm.fields.isOkayToPublish, details, "isOkayToPublish");

                // archiving
                vmHelper.mapToDateField(vm.fields.archiveDate, details, "archiveDate");
                vmHelper.mapToDateField(vm.fields.destructionDate, details, "destructionDate");

                //#endregion

                vm.isRefresh(false);
            })
            .fail(function (e) {
                vm.isRefresh(false);

                console.error(e);
            });
        }

        vm.update = function (field) {
            var fieldName = field.propertyName;
            var isId = _.has(field, "id") && field.id();
            var fieldValue = isId ? field.id() : field.value();

            fieldValue = fieldValue === "" ? null : fieldValue;

            var documentId = vm.document().documentId;

            return dataProvider.documents
            .updateDocumentField(documentId, vm.document().libraryId, fieldName, fieldValue)
            .done(function () {
                _load(vm.document(), true)
                .done(function () {
                    _cacheUpdateDetailsField(documentId, fieldName, fieldValue);

                    vm.eventBroker.trigger(vm, vm.config.events.explorer.results.kendoGridRowUpdateColumn, { documentId: documentId, field: fieldName, value: field.value() });
                })
                .always(function () {
                });
            });
        };        

        vm.updateDocumentClass = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                var itm = this;

                vm.document().documentClass = itm.id;
               
                updateDocumentClass(itm.id)
                .done(function () {
                    vm.fields.documentClass.reset(itm);
                    vm.fields.documentClass.active(itm);

                    complete();
                });
            }
        });
        //#endregion
        
        //#region Version
        function _loadVersion(documentId, refresh) {
            var d = $.Deferred();

            function buildKendoGridVersion() {
                var self = this;

                self.$grid = $("#document-version-list-grid");

                var columns = [
                                { field: "version", title: "Version", width: 65 },
                                { field: "versionNotes", title: "Version Notes", width: 200 },
                                { field: "documentControlStatus", title: "Status", width: 100 }
                ];

                vm.kendoGridVersion = self.$grid.kendoGrid({
                    dataSource: getKendoGridDataSource(),
                    resizable: true,
                    reorderable: true,
                    dataBound: function (e) {
                        var grid = $("#document-version-list-grid").data('kendoGrid');
                        grid.table.toggleClass('k-selectable');
                    },
                    sortable: true,
                    columns: columns,
                    selectable: false,
                    scrollable: true,
                }).data("kendoGrid");

                function getKendoGridDataSource() {
                    var schema = {
                        model: {
                            id: "documentId",
                            fields: {
                                documentId: { type: "string" },
                                version: { type: "string" },
                                versionNotes: { type: "string" },
                                documentControlStatus: { type: "string" }
                            }
                        }
                    };

                    return new kendo.data.DataSource({
                        transport: {
                            read: function (callbacks) {
                                callbacks.success(vm.version.documentVersionList());
                            }
                        },
                        schema: schema,
                        pageSize: 50
                    });
                }
            }

            vm.version.documentId(documentId);
            vm.version.documentIdVersion(vm.document().docIdVersion);
            
            refresh = refresh || vm.document()._oid == null ? true : false;
            
            _cacheGetVersion(documentId, refresh)
            .done(function (docVersion) {

                if (refresh) {
                    var dd = new Date();
                    var _oid = dd.getHours() + '' + dd.getMinutes() + '' + dd.getSeconds();
                    
                    vm.document()._oid = _oid;
                }

                vm.version.documentVersion(docVersion.versionDisplayText);
                vm.version.isCurrentVersion(docVersion.isCurrentVersion);
                vm.version.documentStatus(mapDocumentStatus(docVersion.documentControlStatuses));
                vm.version.documentVersionList(docVersion.documentVersions);
                vm.version.versionNotes(docVersion.versionNotes);
                vm.version.duplicateAsVersionText(String.format(i19n.to.duplicateasversion_, docVersion.nextVersionText));
                vm.version.uploadAsVersionText(String.format(i19n.to.uploadasversion_, docVersion.nextVersionText));
                vm.version.duplicateVersionAsVersionText(String.format(i19n.to.duplicateversion_asversion_, docVersion.version, docVersion.nextVersionText));

                $("#versionNotes").val(vm.version.versionNotes()); //work around not binding properly

                if (docVersion.version) {
                    $("#noversion").hide();
                    $("#withversion").show();
                } else {
                    $("#noversion").show();
                    $("#withversion").hide();
                }

                if (vm.kendoGridVersion)
                    vm.kendoGridVersion.dataSource.read();
                else
                    buildKendoGridVersion();

                $(".tooltips").click(function (e) {
                    e.preventDefault();

                    if (this.parentElement.className !== "disabled") {
                        $(e.currentTarget.parentElement.parentElement).children("li").each(function () {
                            if (this.classList[0] === "active")
                                $(this).removeClass();
                        });

                        vm.version.documentStatusId(e.currentTarget.dataset.itemid);
                        $(e.currentTarget.parentElement).addClass("active");
                    }
                });

                updateVersionSlider(vm.version.documentStatus());

                d.resolve(docVersion);
            })
            .fail(function (e) {
                d.reject(e);

                console.error(e);
            })
            .always(function () {
                //ctxDetails.selectedTab().isBusy(false);
            });

            return d.promise();
        }

        vm.versionDuplicateAskConfirm = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                dataProvider.documents.version
                .saveNewVersion(vm.document().documentId)
                .done(function (result) {
                    vm.version.documentId(result);

                    _cacheGetVersion(vm.document().documentId, true)
                    .done(function (docVersion) {
                        vm.version.documentVersionList(docVersion.documentVersions);
                        vm.version.duplicateAsVersionText(String.format(i19n.to.duplicateasversion_, docVersion.nextVersionText));
                        vm.version.uploadAsVersionText(String.format(i19n.to.uploadasversion_, docVersion.nextVersionText));
                        vm.version.alertMessage(i19n.to.version + " " + (docVersion.nextVersionText - 1) + " " + i19n.to.created);

                        $("#alertMessage").show();

                        if (vm.kendoGridVersion)
                            vm.kendoGridVersion.dataSource.read();

                        ctx.onReloadFolders({ documentId: result, _updateNode: { docCount: ctx.current.folder.docCount + 1, text: ctx.current.folder.name() }, isLoadResults: true });
                    });
                })
                .fail(function (e) {
                    console.error(e);
                })
                .always(function () {
                    vm.version.isShowConfirmDuplicate(false);

                    complete();                    
                });
            }
        });
        vm.versionDuplicateAskCancel = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                vm.version.isShowConfirmDuplicate(false);

                complete();
            }
        });

        vm.versionDuplicate = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                if (!vm.version.isCurrentVersion())
                    vm.version.isShowConfirmDuplicate(true);
                else
                    vm.versionDuplicateAskConfirm(complete);

                complete();
            }
        });
        vm.versionUpload = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                complete();

                router.navigate("actionsUploadAsVersion");
            }
        });
        vm.versionChangeToControlled = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                //var cs = mapDocumentClass([{ id: 0, name: 'Working' }, { id: 1, name: 'Email' }, { id: 2, name: 'Controlled' }], details.documentClass);
                //vm.fields.documentClass.dropdown(cs);
                //vm.fields.documentClass.active(cs[details.documentClass]);

                var itm = {
                    id: 2,
                    name: "Controlled",
                    isActive: ko.observable(true)
                };

                //var itm = vm.fields.documentClass.dropdown()[2];

                vm.document().documentClass = itm.id;
                
                updateDocumentClass(itm.id)
                .done(function () {
                    if (vm.fields.documentClass) {
                        vm.fields.documentClass.reset(itm);
                        vm.fields.documentClass.active(itm);
                    }
                })
                .always(function () {
                    complete();
                });
            }
        });
        vm.versionSave = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                saveDocumentVersion({ documentControlStatusId: vm.version.documentStatusId() })
                .done(function () {
                    var docVersion = _cacheUpdateVersionControlStatus(vm.document().documentId, vm.version.documentStatusId());

                    //ctx.onReloadResults({ documentId: vm.document().documentId });

                    vm.version.alertMessage(i19n.to.documentstatusupdated + " " + vm.version.documentIdVersion());

                    $("#alertMessage").show();

                    vm.version.documentStatus(mapDocumentStatus(docVersion.documentControlStatuses));
                    updateVersionSlider(vm.version.documentStatus());

                    var stat = _.findWhere(vm.version.documentStatus(), { documentControlStatusId: vm.version.documentStatusId() });
                    if (stat) {
                        vm.eventBroker.trigger(vm, vm.config.events.explorer.results.kendoGridRowUpdateColumn, { documentId: vm.document().documentId, field: "documentControlStatusId", value: stat.documentControlStatusId });
                        vm.eventBroker.trigger(vm, vm.config.events.explorer.results.kendoGridRowUpdateColumn, { documentId: vm.document().documentId, field: "documentControlStatus", value: stat.name });
                        vm.eventBroker.trigger(vm, vm.config.events.explorer.results.kendoGridRowUpdateColumn, { documentId: vm.document().documentId, field: "documentControlStatusDescription", value: stat.description });
                    }

                    _cacheGetVersion(vm.document().documentId, true)
                    .done(function (docVersion) {
                        vm.version.documentVersionList(docVersion.documentVersions);

                        if (vm.kendoGridVersion) {
                            vm.kendoGridVersion.dataSource.read();                            
                        }
                    });
                })
                .fail(function (e) {
                    updateVersionSlider(vm.version.documentStatus());

                    console.error(e);
                })
                .always(function () {
                    complete();
                });
            }
        });
        vm.versionCancel = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                vm.showVersion();

                complete();
            }
        });
        //#endregion

        //#region History
        function _loadHistory(documentId, refresh) {
            var d = $.Deferred();

            function buildKendoGridHistory() {
                var self = this;

                self.$grid = $("#document-history-list-grid");

                var columns = [
                    { template: '<input type="radio" name="newversion" id="historyGrid-checkbox" style="height:15px" />', width: 25 },
                    { field: "actionLabel", title: "Action", width: 70 },
                    { field: "when", title: "When", type: "date", format: "{0:g}", width: 90 }, //d MMM yyyy hh:mm tt
                    { field: "whoLabel", title: "Who", width: 100 }
                ];

                vm.kendoGridHistory = self.$grid.kendoGrid({
                    dataSource: getKendoGridHistoryDataSource(),
                    resizable: true,
                    reorderable: true,
                    sortable: true,
                    dataBound: function (e) {
                        var view = this.dataSource.view();

                        for (var i = 0; i < view.length; i++) {
                            var row = view[i];

                            if (!row.documentId || row.previousDocumentSequence == null) {
                                this.tbody.find("tr[data-uid='" + row.uid + "']").find("#historyGrid-checkbox").hide();
                            }
                        }
                    },
                    columns: columns,
                    scrollable: true,
                    selectable: false,
                }).data("kendoGrid");

                function getKendoGridHistoryDataSource() {
                    var schema = {
                        model: {
                            id: "documentId",
                            fields: {
                                documentId: { type: "string" },
                                actionLabel: { type: "string" },
                                when: { type: "date" },
                                whoLabel: { type: "string" },
                                previousDocumentSequence: { type: "string" }
                            }
                        }
                    };

                    return new kendo.data.DataSource({
                        transport: {
                            read: function (callbacks) {
                                callbacks.success(vm.history.historyList());
                            }
                        },
                        schema: schema,
                        pageSize: 50
                    });
                }

                function onRow(e) {
                    if (e.toElement.id == "historyGrid-checkbox") {
                        vm.kendoGridHistory.table.find("tr.k-state-selected").removeClass("k-state-selected");

                        $(this).addClass("k-state-selected");
                    }
                }
                function onTick() {
                    var $row = $(this).closest("tr"),
                        grid = $("#document-history-list-grid").data("kendoGrid"),
                        dataItem = grid.dataItem($row);

                    vm.history.revDocumentId(dataItem.documentId);
                    vm.history.revisionNo(dataItem.previousDocumentSequence);
                }

                vm.kendoGridHistory.table.off("click", "#historyGrid-checkbox", onTick);
                vm.kendoGridHistory.table.on("click", "#historyGrid-checkbox", onTick);
                vm.kendoGridHistory.table.off("click", "tr", onRow);
                vm.kendoGridHistory.table.on("click", "tr", onRow);
            }

            vm.history.documentId(documentId);
            vm.history.revDocumentId(null);
            vm.history.revisionNo(null);

            _cacheGetHistory(documentId, refresh)
            .done(function (data) {
                vm.history.historyList(data.history);

                if (vm.kendoGridHistory) {
                    vm.kendoGridHistory.dataSource.read();
                } else {
                    buildKendoGridHistory();
                }

                d.resolve();
            })
            .fail(function (e) {                
                d.reject(e);

                console.error(e);
            })
            .always(function () {
                //ctxDetails.selectedTab().isBusy(false);
            });

            return d.promise();
        }

        vm.historyDownload = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting && vm.history.revDocumentId() && vm.history.revisionNo();
            },
            execute: function (complete) {
                var url = dataProvider.documents.history.downloadRevision(vm.history.revDocumentId(), vm.history.revisionNo());
                
                window.open(url, "_blank");

                complete();
            }
        });
        vm.historyRestore = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting && vm.history.revDocumentId() && vm.history.revisionNo();
            },
            execute: function (complete) {
                var promise = null, documents = [];

                documents.push({
                    documentId: vm.history.revDocumentId(),
                    folderId: vm.document().folderId
                });

                dataProvider.documents.actions
                .canRestorePriorRevision(documents)
                .done(function (result) {
                    if (!result.success) {
                        promise = dialogService.showDialog("modals/secured/explorer/details/tabs/actions/DocumentActionErrorModal", [result]);
                    } else {
                        promise = dialogService.showMessageBox(i19n.to.restoreselecteddocument, i19n.to.areyousureyouwanttoreplacethecurrentrevisionwiththepriorrevisionselected, _.toArray(_i19n.historypane.dialog.options));

                        promise.then(function (dialogResult) {
                            if (dialogResult.label.toLowerCase() == i19n.to.restore.toLowerCase()) {
                                dataProvider.documents.history
                                .restoreRevision(vm.history.revDocumentId(), vm.history.revisionNo())
                                .done(function () {
                                    ctx.onReloadResults({ documentId: vm.history.revDocumentId() });
                                })
                                .always(function () {
                                    complete();
                                });
                            } else {
                                complete();
                            }
                        });
                    }
                })
                .fail(function () {
                    complete();
                });
            }
        });
        //#endregion

        return vm;

        function _load(document, refresh) {
            if (!document)
                return $.when(true);

            //ctxDetails.selectedTab().isBusy(true);
            //setTimeout(function () {
            //  ctxDetails.selectedTab().isBusy(false);
            //}, 500);             
            

            if (vm.isActiveTabDetail == 'preview')
                return _loadPreview(document, refresh);

            if (vm.isActiveTabDetail == 'profile')
                return _loadDetails(document, refresh);

            if (vm.isActiveTabDetail == 'version')
                return _loadVersion(document.documentId, refresh);

            if (vm.isActiveTabDetail == 'history')
                return _loadHistory(document.documentId, refresh);
        }
        
        function getViewModelHelper() {
            return {
                getCheckedField: function (id, name, i19nField) {
                    var field = getField(id, name, i19nField.label, null);
                    field.reset = ko.observable(true).extend({ notify: 'always' });
                    return field;
                },
                getTextField: function (id, name, i19nField, options) {
                    var field = getField(id, name, i19nField.label, i19nField.placeholder);
                    if (options) {
                        if (options.rows) {
                            field.rows = ko.observable(options.rows);
                        }
                    }
                    return field;
                },
                getNumberField: function (id, name, i19nField, options) {
                    var field = getField(id, name, i19nField.label, i19nField.placeholder);
                    field.options = ko.observable(options);
                    return field;
                },
                getDateField: function (id, name, i19nField, options) {
                    var field = getField(id, name, i19nField.label, i19nField.placeholder);
                    field.options = ko.observable(options);
                    return field;
                },
                getDateTimeField: function (id, name, i19nField, options) {
                    options = options || {};
                    options.isDateTime = true;

                    var field = getField(id, name, i19nField.label, i19nField.placeholder);
                    field.options = ko.observable(options);
                    return field;
                },
                getLookupField: function (id, lookupId, name, lookupName, i19nField) {
                    var field = getField(id, name, i19nField.label, i19nField.placeholder);
                    field.id = ko.observable().extend({ notify: 'always' });
                    field.lookup = lookupName;
                    field.lookupId = lookupId;
                    return field;
                },
                getReadOnlyField: function () {
                    return {
                        visible: ko.observable(false).extend({ notify: 'always' }),
                        value: ko.observable().extend({ notify: 'always' })
                    };
                },
                getPathOnly: function () {
                    return {
                        value: ko.observable().extend({ notify: 'always' })
                    };
                },
                mapToReadOnlyField: function (viewModelField, dataField, parseFn) {
                    parseFn = parseFn || function (value) { return value; };

                    if (dataField != null) {
                        viewModelField.value(parseFn(dataField.value || dataField));
                        viewModelField.visible(true);
                    } else {
                        viewModelField.value(null);
                        viewModelField.visible(false);
                    }
                },
                mapToTextField: function (viewModelField, dataObject, dataProperty) {
                    mapToField(viewModelField, dataObject, dataProperty);
                },
                mapToNumberField: function (viewModelField, dataObject, dataProperty) {
                    mapToField(viewModelField, dataObject, dataProperty);
                },
                mapToDateField: function (viewModelField, dataObject, dataProperty) {
                    if (dataObject != null && dataProperty != null && _.has(dataObject, dataProperty) && dataObject[dataProperty].value)
                        dataObject[dataProperty].value = kendo.parseDate(dataObject[dataProperty].value);
                    mapToField(viewModelField, dataObject, dataProperty);
                },
                mapToDateTimeField: function (viewModelField, dataObject, dataProperty) {
                    this.mapToDateField(viewModelField, dataObject, dataProperty);
                },
                mapToCheckedField: function (viewModelField, dataObject, dataProperty) {
                    viewModelField.reset(true);
                    mapToField(viewModelField, dataObject, dataProperty);
                },
                mapToLookupField: function (viewModelField, dataObject, dataProperty) {
                    mapToField(viewModelField, dataObject, dataProperty);

                    if (dataObject != null && _.has(dataObject, dataProperty) && dataObject[dataProperty] != null) {
                        viewModelField.id(dataObject[dataProperty].id);
                    }
                },
            };

            function getField(id, name, label, placeholder) {
                var field = {
                    fieldId: id,
                    fieldName: name,
                    propertyName: null,
                    visible: ko.observable(false).extend({ notify: 'always' }),
                    editable: ko.observable(true).extend({ notify: 'always' }),
                    required: ko.observable(false).extend({ notify: 'always' }),
                    value: ko.observable().extend({ notify: 'always' }),
                    label: label,
                    placeholder: placeholder,
                    lookupId: ""
                };

                field.required.subscribe(function (required) {

                    if (!required && field.value.rules) {
                        field.value.rules.remove(function (item) {
                            return item.rule = "required";
                        });
                    } else if (required) {
                        field.value.extend({ required: true });
                    }
                });

                field.visible.subscribe(function (value) {                    
                    vm.editLayout.save(field.fieldId, value);
                });
                
                return field;
            }
            function mapToField(viewModelField, dataObject, dataProperty) {
                var dataField = _.has(dataObject, dataProperty) ? dataObject[dataProperty] : null;

                if (dataField != null) {
                    viewModelField.value(dataField.value);
                    viewModelField.visible(true);
                    viewModelField.editable(vm.canEdit()); //vm.editable()
                    viewModelField.required(dataField.required);
                    viewModelField.propertyName = dataProperty;
                } else {
                    viewModelField.visible(false);
                }
            }
        }
        function getDocumentClasses() {
            var d = $.Deferred();

            if (_documentClasses.length == 0) {
                librariesService
                .getLookupValues(vm.document().libraryId, "DocumentClass")
                .done(function (data) {
                    _documentClasses = data;
                    
                    d.resolve(_documentClasses);
                })
                .fail(function (e) {
                    d.reject(e);

                    console.error(e);
                });
            } else {
                d.resolve(_documentClasses);
            }

            return d.promise();
        }
        function saveDocumentVersion(data) {
            var d = $.Deferred();
    
            dataProvider.documents.version
            .saveDocumentVersion(vm.document().documentId, data)
            .done(function () {
                d.resolve();
            })
            .fail(function (e) {
                d.reject(e);

                console.error(e);
            });

            return d.promise();
        }
        function updateDocumentClass(fieldValue) {
            var d = $.Deferred();

            var initVersion = $("#seedversion").data("kendoNumericTextBox").value();
            
            dataProvider.documents
            .updateDocumentClassField(vm.document().documentId, vm.document().libraryId, "documentClass", fieldValue, initVersion)
            .done(function (data) {
             
                if (fieldValue == 2) { //controlled
                    saveDocumentVersion({ documentControlStatusId: "5facc19a-cfc5-4332-8260-e08e9a5167e5" })
                    .done(function () {
                        vm.eventBroker.trigger(vm, vm.config.events.explorer.results.kendoGridRowUpdateColumn, { documentId: vm.document().documentId, field: "documentClass", value: "2" });
                        vm.eventBroker.trigger(vm, vm.config.events.explorer.results.kendoGridRowUpdateColumn, { documentId: vm.document().documentId, field: "docIdVersionId", value: vm.document().docIdVersionId + "-" + initVersion });

                        _cacheUpdateDetailsField(vm.document().documentId, "documentClass", "2");

                        _loadVersion(vm.document().documentId, true)
                        .done(function () { d.resolve(data); })
                        .fail(function (e) { d.reject(e); });
                    })
                    .fail(function (e) {
                        d.reject(e);
                    });

                } else {
                    vm.eventBroker.trigger(vm, vm.config.events.explorer.results.kendoGridRowUpdateColumn, { documentId: vm.document().documentId, field: "documentClass", value: fieldValue });

                    _cacheUpdateDetailsField(vm.document().documentId, "documentClass", fieldValue);

                    d.resolve(data);
                }
            })
            .fail(function () {
                d.reject();
            });

            return d.promise();
        }        
        function updateVersionSlider(statuses) {            
            $('#document-status-slider').remove();
            $('#document-status-slider-container').append('<div id="document-status-slider"></div>');

            $('#document-status-slider').slider({
                value: statuses.length,
                min: 1,
                max: statuses.length,
                step: 1,
                orientation: 'vertical',
                slide: function (e, ui) {
                    var c = ui.value;
                    var b = ($('#document-status-slider-label-id' + c).hasClass('disabled'));
                    if (b)
                        return false;

                    var p = $('#document-status-slider').slider('value');

                    $('#document-status-slider-label-id' + p).removeClass('active');
                    $('#document-status-slider-label-id' + c).addClass('active');

                    var id = $('#document-status-slider-label-id' + c).attr('uid');

                    vm.version.documentStatusId(id);                    

                    return true;
                }
            })
            .each(function () {
                var opt = $(this).data('ui-slider').options;
                var vals = opt.max - opt.min;
                var i = 0; ii = opt.max;
                var isDisabled = true;
                var status = '';

                var isDraftable = _.find(statuses, function (itm) {
                    // drafting 
                    // reviewing 
                    // approving
                    return itm.currentStatus == 'active' &&
                        (itm.documentControlStatusId == "5facc19a-cfc5-4332-8260-e08e9a5167e5" ||
                         itm.documentControlStatusId == "f8777d21-5fa9-44c4-8176-1fa4977287f5" ||
                         itm.documentControlStatusId == "3fc131e7-4500-47c5-85cd-42da7850caac");
                });

                if (!isDraftable)
                    status = 'disabled';

                _.map(statuses, function (itm) {
                    if (itm.currentStatus == 'active') {
                        status = 'active';

                        vm.editable((itm.documentControlStatusId == "5facc19a-cfc5-4332-8260-e08e9a5167e5" || itm.documentControlStatusId == "f8777d21-5fa9-44c4-8176-1fa4977287f5") && !(document.accessControlRoleId == 20 || document.accessControlRoleId == 30));
                    }

                    createLabel(i, itm.documentControlStatusId, itm.name, itm.description, status);

                    if (status == 'active') {
                        status = '';
                        ii = opt.max - i;
                    }

                    i++;
                });

                $('#document-status-slider').slider('option', 'value', ii);

                function createLabel(i, id, name, description, status) {
                    var top = (i / vals * 100) + '%';

                    //var t =
                    //'<div style="top:' + top + '" class="tooltip fade right in" role="tooltip">' +
                    //'   <div class="tooltip-arrow">' +
                    //'      <div class="tooltip-inner">' +
                    //       description + 
                    //'      </div>' +
                    //'   </div>' +
                    //'</div>';  

                    var t = '<p style="top:' + top + '; width: 250px;" class="description">' + description + '</p>';
                    var s = '<label style="top:' + top + '"' +
                                     'title="' + description + '" ' +
                                       'uid="' + id + '"' +
                                        'id="document-status-slider-label-id' + (opt.max - i).toString() + '" ' +
                                     'class="' + status + '">' + name + '</label>' + t;

                    $('#document-status-slider').append($(s));
                }
            });

            //var opt = $('#document-status-slider').data('ui-slider').options;
            //for (var i = 0; i < 7; i++) {
            //    $('#document-status-slider-label-id' + (7 - i).toString())
            //        .tooltip({ placement: 'right', trigger: 'manual' }).tooltip('show');
            //}
        }
        function mapDocumentStatus(statuses) {
            return _.map(statuses, function (itm) {
                if (itm.isCurrentStatus === true)
                    vm.version.documentStatusId(itm.documentControlStatusId);

                return {
                    description: itm.description,
                    name: itm.name,
                    currentStatus: itm.isCurrentStatus === true ? "active" : "disabled",
                    documentControlStatusId: itm.documentControlStatusId
                };
            });
        }        

        function _cacheUpdateDetailsField(documentId, fieldName, fieldValue) {
            var f = _.find(_documentDetails, function (itm) { return !itm || !itm.details ? false : itm.details.documentId == documentId; });

            if (f) {
                if (f.details[fieldName].id !== undefined)
                    f.details[fieldName].id = fieldValue;
                else if (f.details[fieldName].value !== undefined)
                    f.details[fieldName].value = fieldValue;
                else
                    f.details[fieldName] = fieldValue;
            }

            return f;
        }
        function _cacheUpdateVersionControlStatus(documentId, id) {
            var f = _.find(_documentVersions, function (itm) { return !itm ? false : itm.id == documentId; });

            if (f) {
                f.documentControlStatusId = id;
                _.map(f.documentControlStatuses, function (itm) {
                    itm.isCurrentStatus = itm.documentControlStatusId == id;
                });
            }

            return f;
        }
        function _cacheUpdateVersionNotes(documentId, notes) {
            var f = _.find(_documentVersions, function (itm) { return !itm ? false : itm.id == documentId; });

            if (f) {                
                f.versionNotes = notes;
            }

            return f;
        }
        
        function _cacheGetDetails(documentId, libraryId, refresh) {
            var d = $.Deferred();

            refresh = refresh || false;
            
            var f = _.find(_documentDetails, function (itm) { return !itm || !itm.details ? false : itm.details.documentId == documentId; });
            if (refresh)
                _documentDetails = _.without(_documentDetails, f);

            if (f && !refresh) {
                d.resolve(f);
            } else {
                var promise = dataProvider.documents.getDocumentDetails(documentId, libraryId);

                documentService.busyTracker.add(promise);

                promise.done(function (results) {
                    _documentDetails.push(results);

                    d.resolve(results);
                })
                .fail(function (e) {
                    d.reject(e);

                    console.error(e);
                });

                return promise;
            }

            return d.promise();
        }
        function _cacheGetVersion(documentId, refresh) {
            var d = $.Deferred();

            refresh = refresh || false;

            var f = _.find(_documentVersions, function (itm) { return !itm ? false : itm.id == documentId; });
            if (refresh)
                _documentVersions = _.without(_documentVersions, f);

            if (f && !refresh) {
                d.resolve(f);
            } else {
                var promise = dataProvider.documents.version.getDocumentVersion(documentId);

                promise.done(function (results) {
                    _documentVersions.push(results);

                    d.resolve(results);
                })
                .fail(function (e) {
                    d.reject(e);

                    console.error(e);
                });

                return promise;
            }

            return d.promise();
        }
        function _cacheGetHistory(documentId, refresh) {
            var d = $.Deferred();

            refresh = refresh || false;
            
            var f = _.find(_documentHistory, function (itm) { return !itm ? false : itm.documentId == documentId; });
            if (refresh)
                _documentHistory = _.without(_documentHistory, f);

            if (f && !refresh) {
                d.resolve(f);
            } else {
                var promise = dataProvider.documents.history.getDocumentHistory(documentId);

                promise.done(function (results) {
                    _documentHistory.push(results);

                    d.resolve(results);
                })
                .fail(function (e) {
                    d.reject(e);

                    console.error(e);
                });

                return promise;
            }

            return d.promise();
        }
    });
